import React, { Fragment, useState, useEffect } from 'react';
import moment from 'moment';
import { Link, withRouter } from 'react-router';
import { useSnackbar } from 'notistack';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { read, utils } from 'xlsx';
import AddIcon from '@material-ui/icons/Add';
import { Paper, Button, Dialog, Grid, TextField, DialogActions, DialogContent, DialogTitle, Table, TableHead, TableBody, TableCell, CircularProgress, TableRow, Tabs, Tab, Tooltip } from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { globalGetService, globalPostService } from '../../../utils_v2/globalApiServices';
import { checkApiStatus, isPositiveInteger, onCheckPermission } from '../../../utils_v2';
import { regexConstants } from '../../../constants/regEx';
import { displayDateTimeFormatShort } from '../../../constants/';
import { trackActivity } from '../../../utils/mixpanel';
import { globalStaticPostService } from '../../../globalServices';
import { castleAirInstance } from '../../../shared_elements/components';

const ImportTemplate = ({ params, importTemplate, toggleModalFn, getResponseBack }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [tabIndex, setTabIndex] = useState(0);
    const [modal, setModal] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [importCrud, setImportCrud] = useState({ template: null });
    const [templates, setTemplates] = useState([])
    const [pres, setPres] = useState([]);
    const [error, setError] = useState([]);
    const [showMsg, setShowMsg] = useState(false);
    const [tempTabIndx, setTempTabIndx] = useState(0);
    const [questionsData, setQuestionsData] = useState([]);
    const [presError, setPresError] = useState({});
    const getFormTemplates = (query) => {
        globalGetService(`technical/templates/`, { type: 'T013' })
            .then(response => {
                if (checkApiStatus(response)) {
                    setTemplates(response.data.data.list)
                }
            });
    }
    const onSpartaTemplate = (value) => {
        if (value === 1) {
            setLoading(true);
            globalGetService(`technical/v2/workorder/${params.workOrderSlug}/document-default-sections/?asset_type=${params.type}`)
                .then(response => {
                    setLoading(false);
                    if (checkApiStatus(response)) {
                        setPres(response.data.data);
                    } else {

                    }
                })
        }
    }
    const onChangeTemplate = (template) => {
        setPresError({})
        setImportCrud({ template });
        setLoading(true);
        if (template) {
            (async () => {
                const f = await (await fetch(template.file_path)).arrayBuffer();
                const wb = read(f); // parse the array buffer
                if (wb.SheetNames.includes("Questions") && wb.SheetNames.includes("Sections") && castleAirInstance) {
                    const questionData = utils.sheet_to_json(wb.Sheets['Questions'], { blankRows: false });
                    const sectionData = utils.sheet_to_json(wb.Sheets['Sections'], { blankRows: false });
                    setQuestionsData(questionData)
                    setPres(sectionData)
                }
                else {
                    const ws = wb.Sheets[wb.SheetNames[0]]; // get the first worksheet
                    const data = utils.sheet_to_json(ws, { blankRows: false }); // generate objects
                    setPres(data); // update state
                    setQuestionsData([])
                }
                setLoading(false);
            })();
        } else {
            setPres([]);
            setQuestionsData([])
            setLoading(false);
        }
    }
    const onFieldChange = (e, keyParam, value, index) => {
        setPres(pres.map((item, itemIndex) => itemIndex !== index ? item : { ...item, [keyParam]: value }))
    }
    const onFieldChangeQuestion=(e, keyParam,value, index)=>{
        setQuestionsData(questionsData.map((item, itemIndex)=> itemIndex !== index? item:{...item,[keyParam]:value}))
    }
    const onRemove = (index) => {
        setPres(pres.filter((item, itemIndex) => itemIndex !== index))
    }
     const onRemoveQuestion =(index)=>{
        setQuestionsData(questionsData.filter((item, i)=>i !==index ))
    }
    const onSetupTemplate = () => {
        // Validations for Template Import;
         let validateSection = {}
                validateSection = {
                    ...validateSection,
                    section: pres[0] && pres[0]['Section Name'] ? '' : pres?.length ?'Please Enter Section Name.':'',
                    questionSection: castleAirInstance ? questionsData[0] ? questionsData[0]['Section Name'] ? '' : 'Please Enter Section Name.' : '' : '',
                }
                if (validateSection?.section || validateSection?.questionSection) {
                    enqueueSnackbar('Please enter mandatory details to proceed.', { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                    setPresError(validateSection)
                } else {
        setLoading(true); setShowMsg(true);
         let payload = questionsData.length ? {main_sections:pres,questions:questionsData}: {main_sections:pres}
        globalStaticPostService(`technical/v2/workorder/${params.workOrderSlug}/workbook/import/?asset_type=${params.type}`, payload)
            .then(response => {
                setLoading(false); setShowMsg(false);
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                    window.location.reload();
                    setModal(false);
                    trackActivity('Project Management', {
                        event_type: 'Template Import Success',
                        page_title: 'T003 Form',
                        workOrder_slug: params.workOrderSlug ? params.workOrderSlug : '',
                        request_body: pres ? pres : '',
                        response: response.data.data,
                        success_msg: response.data.message
                    });
                } else {
                    enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                    trackActivity('Project Management', {
                        event_type: 'Template Import Failed',
                        page_title: 'T003 Form',
                        workOrder_slug: params.workOrderSlug ? params.workOrderSlug : '',
                        request_body: pres ? pres : '',
                        error_msg: response.data.data,
                        error_source: 'Backend'
                    });
                }
            })
    }}
    const getRootState =()=>{
     setTempTabIndx(0);
     setQuestionsData([]);
     setPres([]);
     setPresError({});
     setImportCrud({template:null})
}
    return (
        <Fragment>
            <div className='import-form-template'>
                <h4>There is no section mapped to this form right now</h4>
                <p>Please choose the template to map the section</p>
                <Button onClick={() => { getFormTemplates(); getRootState(); setModal(true) }} color='primary' variant='outlined' size='small' startIcon={<AddIcon color='primary' style={{ fontSize: '1.15rem' }} />}>Import Template</Button>
            </div>
            {modal ?
                <Dialog
                    open={modal}
                    className='project-management-modal'
                    maxWidth={false}
                >
                    <DialogTitle id="scroll-dialog-title">
                        Import Template
                    </DialogTitle>
                    <DialogContent dividers={true} >
                        <div style={{ width: '840px', minHeight: '400px' }}>
                            <Paper>
                                {/* <Tabs
                                    value={tabIndex}
                                    onChange={(event, newValue) => {setPres([]);setTabIndex(newValue);onSpartaTemplate(newValue);setImportCrud({template:null})}}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    variant="fullWidth"
                                >
                                    <Tab label={<span>Custom Template</span>} />
                                    <Tab label={<span>Sparta Template</span>} />
                                </Tabs> */}
                            </Paper>
                            {tabIndex === 0 ?
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={6}>
                                        <Autocomplete
                                            options={templates}
                                            getOptionLabel={option => option.name + ' : ' + moment(option.created_at).format(displayDateTimeFormatShort)}
                                            id="template"
                                            value={importCrud.template}
                                            onChange={(e, value) => onChangeTemplate(value)}
                                            renderInput={params => <TextField required {...params} label="Select Template" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    </Grid>
                                    { onCheckPermission('project_management', 'template','C') ?
                                    <Grid item sm={6} style={{padding:'25px 0px 0px 7px'}} >
                                          or &nbsp;
                                        <Link to='/technical/form/templates/'>
                                            <Button variant='contained' color='primary' ><AddIcon style={{ fontSize: '1.15rem', color:'#fff' }} />
                                                Add New Template
                                            </Button>
                                        </Link>
                                    </Grid>
                                    : null}

                                </Grid> : null
                            }
                            <Grid container spacing={1}>
                                {
                                    isLoading ?
                                        <Grid item sm={12}>
                                            <div style={{ textAlign: 'center', marginTop: '45px' }} >
                                                <CircularProgress size={40} />
                                            </div>
                                        </Grid> : null
                                }
                                {questionsData?.length && castleAirInstance ?
                                    <Tabs
                                        value={tempTabIndx}
                                        onChange={(event, newValue) => { setTempTabIndx(newValue) }}
                                        indicatorColor="primary"
                                        textColor="primary"
                                    >
                                        <Tab label='Sections' />
                                        <Tab label='Questions' />
                                    </Tabs> : null}
                                {
                                    tempTabIndx == 0 ?
                                        <Grid item md={12}>
                                            {pres.length ?
                                                <div style={{ overflowX: 'auto' }}>
                                                <Table className='mui-table-format'>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell><div style={{minWidth:'150px'}}>Section Name<sup>*</sup></div></TableCell>
                                                            <TableCell><div style={{minWidth:'150px'}}>Sub Section Name</div></TableCell>
                                                            <TableCell>Checklist</TableCell>
                                                            <TableCell>Notes</TableCell>
                                                            {castleAirInstance? <TableCell>Finding Summary</TableCell>:null}
                                                            {castleAirInstance? <TableCell>Summary Notes</TableCell>:null}
                                                            <TableCell>Action</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        { /* generate row for each president */
                                                            pres.map((pre, index) => (
                                                                <TableRow>
                                                                    <TableCell>
                                                                        
                                                                            <TextField
                                                                                required
                                                                                id={`name_${index}`}
                                                                                fullWidth
                                                                                margin="none"
                                                                                value={pre['Section Name']|| ''}
                                                                                onChange={(e) => onFieldChange(e, 'Section Name', e.target.value, index)}
                                                                                InputLabelProps={{ shrink: true }}
                                                                                variant='outlined'
                                                                                error={!!presError?.section && index ===0}
                                                                                helperText={index ===0 ?presError?.section:''}
                                                                                onFocus={()=>setPresError({...presError,section:''})}
                                                                            /> 
                                                                    </TableCell>
                                                                    <TableCell>
                                                                            <TextField
                                                                                required
                                                                                id={`description_${index}`}
                                                                                fullWidth
                                                                                margin="none"
                                                                                value={pre['Sub Section Name']|| ''}
                                                                                onChange={(e) => onFieldChange(e, 'Sub Section Name', e.target.value, index)}
                                                                                InputLabelProps={{ shrink: true }}
                                                                                variant='outlined'
                                                                            /> 

                                                                    </TableCell>
                                                                    <TableCell>
                                                                        { <div style={{ width: '100px' }}>
                                                                                <TextField
                                                                                    required
                                                                                    id={`max_limit_${index}`}
                                                                                    fullWidth
                                                                                    margin="none"
                                                                                    value={pre['Checklist']|| ''}
                                                                                    onChange={(e) => {onFieldChange(e, 'Checklist', e.target.value, index)}}
                                                                                    InputLabelProps={{ shrink: true }}
                                                                                    variant='outlined'
                                                                                />
                                                                            </div> }
                                                                    </TableCell>
                                                                    <TableCell>
                                                                            <div style={{ width: '100px' }}>
                                                                                <TextField
                                                                                    required
                                                                                    id={`physical_order_${index}`}
                                                                                    fullWidth
                                                                                    margin="none"
                                                                                    value={pre['Notes']|| ''}
                                                                                    onChange={(e) => { onFieldChange(e, 'Notes', e.target.value, index) }}
                                                                                    InputLabelProps={{ shrink: true }}
                                                                                    variant='outlined'
                                                                                />
                                                                            </div> 
                                                                    </TableCell>
                                                                    {castleAirInstance ?
                                                                    <TableCell>
                                                                        <div style={{ width: '200px' }}>
                                                                            <TextField
                                                                                required
                                                                                id={`Finding_Summary${index}`}
                                                                                fullWidth
                                                                                margin="none"
                                                                                value={pre['Finding Summary'] ? pre['Finding Summary'] : ''}
                                                                                onChange={(e) => { onFieldChange(e, 'Finding Summary', e.target.value, index) }}
                                                                                InputLabelProps={{ shrink: true }}
                                                                                variant='outlined'
                                                                            />
                                                                        </div>
                                                                    </TableCell> :null}
                                                                    {castleAirInstance ?
                                                                    <TableCell>
                                                                        <div style={{ width: '200px' }}>
                                                                            <TextField
                                                                                id={`finding_summary_notes${index}`}
                                                                                fullWidth
                                                                                margin="none"
                                                                                value={pre['Finding Summary Notes'] ? pre['Finding Summary Notes'] : ''}
                                                                                InputLabelProps={{ shrink: true }}
                                                                                InputProps={{ readOnly: true }}
                                                                                disabled
                                                                                variant='outlined'
                                                                            />
                                                                        </div>
                                                                    </TableCell> :null}
                                                                    <TableCell>
                                                                        {pres.length !== 1 ?
                                                                            <DeleteOutlineIcon color='secondary' onClick={() => onRemove(index)} /> : null
                                                                        }
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))
                                                        }
                                                    </TableBody>
                                                </Table>
                                                </div> : null
                                            }
                                        </Grid> :
                                        <Grid item md={12}>
                                            {questionsData.length ?
                                                <Table className='mui-table-format'>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>Section Name<sup>*</sup></TableCell>
                                                              <TableCell>Sub Section Name</TableCell>
                                                            <TableCell>Question(s)</TableCell>
                                                            <TableCell>Answer(s)</TableCell>
                                                            <TableCell>Note(s)</TableCell>
                                                            <TableCell>Action</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {questionsData.map((pres, index) => (
                                                            <TableRow>
                                                                <TableCell>
                                                                    <TextField
                                                                        id={`${index}`}
                                                                        fullWidth
                                                                        margin="none"
                                                                        value={pres['Section Name']|| ''}
                                                                        InputLabelProps={{ shrink: true }}
                                                                        onChange={(e) => onFieldChangeQuestion(e, 'Section Name', e.target.value, index)}
                                                                        variant='outlined'
                                                                        error={!!presError?.questionSection && index ===0}
                                                                        helperText={index ===0 ?presError?.questionSection:''}
                                                                        onFocus={()=>setPresError({...presError,questionSection:''})}
                                                                    />
                                                                </TableCell>
                                                                <TableCell>
                                                                     <TextField
                                                                                required
                                                                                id={`sub_section${index}`}
                                                                                fullWidth
                                                                                margin="none"
                                                                                value={pres['Sub Section Name']|| ''}
                                                                                onChange={(e) => onFieldChangeQuestion(e, 'Sub Section Name', e.target.value, index)}
                                                                                InputLabelProps={{ shrink: true }}
                                                                                variant='outlined'
                                                                            /> 

                                                                    </TableCell>
                                                                <TableCell>
                                                                    <TextField
                                                                        id={`${index}`}
                                                                        fullWidth
                                                                        margin="none"
                                                                        value={pres['Question']|| ''}
                                                                        InputLabelProps={{ shrink: true }}
                                                                        onChange={(e) => onFieldChangeQuestion(e, 'Question', e.target.value, index)}
                                                                        variant='outlined'
                                                                    />
                                                                </TableCell>
                                                                <TableCell>
                                                                    <TextField
                                                                        id={`${index}`}
                                                                        fullWidth
                                                                        margin="none"
                                                                        value={pres['Answer']|| ''}
                                                                        InputLabelProps={{ shrink: true }}
                                                                        onChange={(e) => onFieldChangeQuestion(e, 'Answer', e.target.value, index)}
                                                                        variant='outlined'
                                                                    />
                                                                </TableCell>
                                                                <TableCell>
                                                                    <div style={{ width: '100px' }}>
                                                                        <TextField
                                                                            required
                                                                            id={`physical_order_${index}`}
                                                                            fullWidth
                                                                            margin="none"
                                                                            value={pres['Notes'] || ''}
                                                                            onChange={(e) => { onFieldChangeQuestion(e, 'Notes', e.target.value, index) }}
                                                                            InputLabelProps={{ shrink: true }}
                                                                            variant='outlined'
                                                                        />
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell>
                                                                    {questionsData.length !== 1 ?
                                                                      <Tooltip title='Delete' arrow><DeleteOutlineIcon color='secondary' onClick={() => onRemoveQuestion(index)} /></Tooltip> 
                                                                      : null}
                                                                </TableCell>
                                                            </TableRow>))}
                                                    </TableBody>
                                                </Table> : null
                                            }
                                        </Grid>

                                }
                            </Grid>
                        </div>
                    </DialogContent>
                    <DialogActions style={{ display: 'contents' }}>
                        <div style={{ textAlign: 'right', margin: '10px', marginRight: '22px' }}>
                            <Button style={{ marginRight: "10px" }} disabled={isLoading} onClick={() => { setModal(false) }} color="primary" size='small' variant='outlined'>Cancel</Button>
                            {pres.length ?
                                <Button disabled={isLoading} onClick={onSetupTemplate} color="primary" size='small' variant='contained'>
                                    {isLoading ? <CircularProgress size={20} /> : 'Save'}
                                </Button> : null
                            }
                        </div>
                        {showMsg ?
                            <span style={{ width: 'max-content', alignSelf: 'center', marginBottom: "10px" }} className='notes-block'>
                                Import in progress - Please don't refresh the page. This may take a few minutes. Thanks for your patience
                            </span>
                            : null}
                    </DialogActions>
                </Dialog> : null
            }
        </Fragment>
    )
}
export default withRouter(ImportTemplate);